import { Component, OnInit } from '@angular/core';
import { signOut } from 'aws-amplify/auth';
import { Router, ActivatedRoute } from '@angular/router';
import { Amplify } from 'aws-amplify';
import { CognitoService } from 'src/service/cognito.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
})
export class LogoutComponent implements OnInit {
  clientId: string | null = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cognitoService: CognitoService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.clientId = params['clientId'] || null;
      if (this.clientId) {
        this.cognitoService.configureOAuth(this.clientId);
      }
    });
    this.handleSignOut();
  }

  async handleSignOut() {
    try {
      await signOut();
      this.router.navigate(['/sign-in'], {
        queryParams: { clientId: this.clientId },
      });
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }
}